<template>
	<div>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានការកម្ចី</h3>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
				<md-card style="margin: 5px 0">
					<!-- <md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
					</md-card-header> -->
					<md-card-content>
						<div>
							<loading v-if="!loaded" />
							<div class="md-layout" v-if="loaded">
								<div class="md-layout-item md-small-size-100 md-size-50">
									<table>
										<tr>
											<td style="width: 150px">កម្ជីចំនួន</td>
											<td style="width: 40px">:</td>
											<td>{{config.moneylify(loan.amount)}}</td>
										</tr>
										<tr>
											<td>រយៈពេលកម្ចី</td>
											<td>:</td>
											<td>{{loan.term}} ខែ</td>
										</tr>
										<!-- <tr>
										<td>Interest rate</td>
										<td>:</td>
										<td>{{loan.interest_rate}}%</td>
									</tr> -->
										<tr>
											<td>ការប្រាក់</td>
											<td>:</td>
											<td>{{config.moneylify(loan.interest_amount)}}</td>
										</tr>

										<tr>
											<td>ប្រាក់ត្រូវបង់សរុប</td>
											<td>:</td>
											<td><b>{{config.moneylify(loan.total_payment)}}</b></td>
										</tr>
										<tr>
											<td>ពេលវេលាកម្ចី</td>
											<td>:</td>
											<td>{{config.datelify(loan.start_date)}} - {{config.datelify(loan.end_date)}}</td>
										</tr>
										<tr>
											<td>ស្ថានភាព</td>
											<td>:</td>
											<td>
												<span class="active"
													v-if="loan.status == 'act'">{{config.getStatusKhmer(loan.status)}}</span>
												<span class="late"
													v-if="loan.status == 'fin'">{{config.getStatusKhmer(loan.status)}}</span>
											</td>
										</tr>

									</table>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<table style="border-width: 0px;">
										<tr>
											<td>ឈ្មោះអ្នកកម្ជី</td>
											<td>:</td>
											<td>{{loan.name}}</td>
										</tr>
										<tr>
											<td style="width: 150px">ប្រាក់បង់ខែដំបូង</td>
											<td style="width:40px">:</td>
											<td>{{config.moneylify(loan.initial_payment)}}</td>
										</tr>
										<tr>
											<td>ប្រាក់បង់ប្រចាំខែ</td>
											<td>:</td>
											<td>{{config.moneylify(loan.monthly_payment)}}</td>
										</tr>
										<tr>
											<td>បានបង់ប្រាក់ប្រចាំខែ</td>
											<td>:</td>
											<td>{{loan.total_paid}} / {{loan.term}}</td>
										</tr>
										<tr>
											<td>ប្រាក់បង់ខែចុងក្រោយ</td>
											<td>:</td>
											<td>{{config.moneylify(loan.final_payment)}}</td>
										</tr>
										<!-- <tr>
									<td>Remaining balance</td>
									<td>:</td>
									<td>{{config.moneylify(loan.loan_balance)}}</td>
								</tr> -->

										<tr>
											<td>ថ្ងៃបង់ប្រាក់បន្ទាប់</td>
											<td>:</td>
											<td>
												<span v-if="loan.total_paid == loan.term">N/A</span>
												<span class="active"
													v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}</span>
											</td>
											<!-- <td><span class="late" v-if="false">12/11/2021</span></td> -->
										</tr>
									</table>
								</div>

								<!-- <div class="md-layout-item md-small-size-100 md-size-100">
									<md-table v-if="paymentList.length > 0">
										<md-table-row>
											<md-table-head>ខែ</md-table-head>
											<md-table-head>លេខកូដបង់ប្រាក់</md-table-head>
											<md-table-head>ថ្ងៃបង់ប្រាក់</md-table-head>
											<md-table-head>ទឹកប្រាក់</md-table-head>
											<md-table-head>ប្រាក់បង់ប្រចាំខែ</md-table-head>
											<md-table-head>សមតុល្យទឹកប្រាក់</md-table-head>
											<md-table-head>ស្ថានភាព</md-table-head>
										</md-table-row>

										<md-table-row v-for="(payment, index) in paymentList">
											<md-table-cell>{{ payment.term_id }}</md-table-cell>
											<md-table-cell>{{ payment.hash_id }}</md-table-cell>
											<md-table-cell>{{ config.datelify(payment.created_date) }}</md-table-cell>
											<md-table-cell>{{ config.moneylify(payment.currentTotal) }}</md-table-cell>

											<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal)}}</b>
											</md-table-cell>

											<md-table-cell>{{ config.moneylify(payment.interestBalance) }}</md-table-cell>

											<md-table-cell>
												<span class="late" v-if="payment.status == 'pnd'">{{ config.getStatusKhmer(payment.status)
													}}</span>
												<span class="active" v-if="payment.status == 'pad'">{{
													config.getStatusKhmer(payment.status)
													}}</span>
											</md-table-cell>
										</md-table-row>
									</md-table>
								</div> -->
							</div>

						</div>
					</md-card-content>
				</md-card>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">ប្រវត្តិបង់ប្រាក់</h3>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
				v-for="(payment, index) in paymentList">
				<md-card class="md-card-stats" style="margin: 5px 0">
					<md-card-content style="text-align: left;">
						<p>
						<table>
							<tr>
								<td>ខែ</td>
								<td class="dot">: </td>
								<td>ខែទី {{ payment.term_id }}</td>
							</tr>
							<tr>
								<td>លេខកូដបង់ប្រាក់</td>
								<td class="dot">: </td>
								<td>{{ payment.hash_id }}</td>
							</tr>
							<tr>
								<td>ថ្ងៃបង់ប្រាក់</td>
								<td class="dot">: </td>
								<td>{{ config.datelify(payment.created_date) }}</td>
							</tr>
							<tr>
								<td>ទឹកប្រាក់</td>
								<td class="dot">: </td>
								<td>{{ config.moneylify(payment.currentTotal) }}</td>
							</tr>
							<tr>
								<td>ប្រាក់បង់ប្រចាំខែ</td>
								<td class="dot">: </td>
								<td>
									<b>{{ config.moneylify(payment.interest + payment.principal)}}</b>
								</td>
							</tr>
							<tr>
								<td>សមតុល្យទឹកប្រាក់</td>
								<td class="dot">: </td>
								<td>
									{{ config.moneylify(payment.interestBalance) }}
								</td>
							</tr>
							<tr>
								<td>ស្ថានភាព</td>
								<td class="dot">: </td>
								<td>
									<span class="late" v-if="payment.status == 'pnd'">{{ config.getStatusKhmer(payment.status)
										}}</span>
									<span class="active" v-if="payment.status == 'pad'">{{
										config.getStatusKhmer(payment.status)
										}}</span>
								</td>
							</tr>
						</table>
						</p>
					</md-card-content>
				</md-card>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="payDialog" md-title="Are you sure want to mark this as paid ?" md-content=""
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="payPayment" />
		<md-dialog-confirm :md-active.sync="payAllDialog"
			:md-title="'Are you sure want to finish this loan ? Total payment is ' + config.moneylify(payAllTotal)"
			md-content="" md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="payAllPayment" />

		<md-dialog-prompt :md-active="lateDialog" md-title="Late Payment Fee" md-confirm-text="Confirm"
			md-cancel-text="Cancel" md-input-maxlength="8" md-input-placeholder="Fee ($)" @md-cancel="onCancel"
			@md-confirm="payLatePayment()" v-model="lateFee" ref="dialog">
		</md-dialog-prompt>
	</div>
</template>
<script>
	export default {
		created() {
			this.getLoan();
			this.getPayment();
			this.getPayAllTotal();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				payDialog: false,
				lateDialog: false,
				payAllDialog: false,
				payID: "",
				payLateID: "",
				lateFee: "",
				payAllTotal: 0,
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash_id).then(data => {
					this.loan = data.body.data
					this.loaded = true
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/admin/loan/get_payment/" + this.$route.params.hash_id).then(data => {
					this.paymentList = data.body.data
					// let
					// for (let i = 0; i < this.paymentList.length; i++) {
					// 	this.paymentList[i].interestBalance =
					// }
				})
			},
			getPayAllTotal() {
				this.$http.get(this.config.api + "/admin/loan/get/pay_all/" + this.$route.params.hash_id).then(data => {
					// this.payAllTotal = data.body.data.balance + data.body.data.interest + data.body.data.fine
					this.payAllTotal = data.body.data.balance + data.body.data.fine
				})
			},
			payPayment(id = "") {
				if (id == "" && String(this.payID).length > 0) {
					this.$http.post(this.config.api + "/admin/loan/pay/payment", {
						payment_id: this.payID,
						late_fee: "0",
						loan_id: this.loan.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getLoan();
						}
					})
				} else {
					this.payID = id;
					this.payDialog = true;
				}

			},
			openLateDialog(id) {
				this.lateDialog = true;
				this.payLateID = id;
			},
			payLatePayment() {

				let id = this.payLateID;
				let fee = this.lateFee;
				this.onCancel();
				if (String(id).length > 0 && String(fee).length > 0) {
					this.$http.post(this.config.api + "/admin/loan/pay/payment", {
						payment_id: id,
						late_fee: fee,
						loan_id: this.loan.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getLoan();
						}
					})
				}

			},
			payAllPayment() {
				this.$http.post(this.config.api + "/admin/loan/pay_all/payment", {
					loan_id: this.loan.id
				}).then(data => {
					if (data.body.status == 'success') {
						this.getPayment();
						this.getLoan();
					}
				})
			},
			onCancel() {
				this.payDialog = false;
				this.lateDialog = false;
				this.payID = "";
				this.lateFee = "";
			}
		}
	}
</script>

<style>
	.dot {
		padding: 0px 30px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ClientLoans/Detail.vue